import { useEffect, useRef, useState } from "react";

import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Image.module.css";

export default function Image({
  className = "",
  src,
  srcSet,
  sizes,
  alt,
  height,
  width,
  backgroundColor = "none",
  fadeInOnLoad,
  handleLoaded = () => {},
}) {
  const [loaded, setLoaded] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current !== null) {
      if (ref.current.complete) {
        setLoaded(true);
        handleLoaded();
      }
    }
  }, []);

  return (
    <div
      className={classNames(className, styles.Image)}
      style={{
        "--ratio": `${(height / width) * 100}%`,
        "--background-color": backgroundColor,
      }}
    >
      <img
        className={classNames({
          [styles.img]: true,
          [styles.loaded]: loaded,
          [styles.fadeInOnLoad]: fadeInOnLoad,
        })}
        src={src}
        srcSet={srcSet}
        sizes={sizes}
        alt={alt}
        ref={ref}
        onLoad={() => {
          setLoaded(true);
          handleLoaded();
        }}
      />
    </div>
  );
}

Image.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  srcSet: PropTypes.string,
  sizes: PropTypes.string,
  alt: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number,
  backgroundColor: PropTypes.string,
  handleLoaded: PropTypes.func,
  fadeInOnLoad: PropTypes.bool,
};
